import { createSlice } from "@reduxjs/toolkit"

export const initialState = {
  loading: false,
  error: null,
  tasks: [],
  task: null
}

export const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setLoading: state => {
      state.loading = true
    },
    setTasks: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.tasks = payload
    },
    setTask: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.task = payload
    },
    taskCreated: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.tasks = [payload, ...state.tasks]
    },
    taskUpdated: (state, { payload }) => {
      state.loading = false
      state.error = null
      const index = state.tasks.findIndex(t => t._id === payload._id)
      if (index !== -1) {
        state.tasks[index] = payload
      }
      if (state.task && state.task._id === payload._id) {
        state.task = payload
      }
    },
    taskDeleted: (state, { payload }) => {
      state.loading = false
      state.error = null
      state.tasks = state.tasks.filter(t => t._id !== payload)
      if (state.task && state.task._id === payload) {
        state.task = null
      }
    },
    setError: (state, { payload }) => {
      state.loading = false
      state.error = payload
    }
  }
})

export const { setLoading, setTasks, setTask, taskCreated, taskUpdated, taskDeleted, setError } = taskSlice.actions

export default taskSlice.reducer
